var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$slots.default)?_c('label',{staticClass:"col-form-label",class:( _obj = {}, _obj[("col-form-label-" + _vm.size)] = _vm.size, _obj )},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }